import { defineMessages } from "react-intl";

export const messages = defineMessages({
  clearAll: {
    id: "ari.management.sortAndFilter.clearAll",
    defaultMessage: "Clear filter",
  },
});
